import { render, staticRenderFns } from "./AppConfirmationModal.vue?vue&type=template&id=7b74ca2d&"
import script from "./AppConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./AppConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports